export const CLIENT_ANNOUNCE = 'client-announce';

export default interface Announce
{
    table_name: string;
}
